import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { importGroupMembers, setupImportResultsState } from './actions'

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            importGroupMembers,
            setupImportResultsState,
        },
        dispatch
    )

const mapStateToProps = (state) => ({
    importResults: state.getIn(['ui', 'groupStack', 'importData', 'importResults']),
    importing: state.getIn(['ui', 'groupStack', 'importData', 'importing']),
    imported: state.getIn(['ui', 'groupStack', 'importData', 'imported']),
    duplicated: state.getIn(['ui', 'groupStack', 'importData', 'duplicated']),
    exists: state.getIn(['ui', 'groupStack', 'importData', 'exists']),
    notFound: state.getIn(['ui', 'groupStack', 'importData', 'notFound']),
    ok: state.getIn(['ui', 'groupStack', 'importData', 'ok']),
    total: state.getIn(['ui', 'groupStack', 'importData', 'total']),
    loading: state.getIn(['ui', 'groupStack', 'groupData', 'loading']),
})

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            duplicated: PropTypes.number.isRequired,
            exists: PropTypes.number.isRequired,
            imported: PropTypes.bool.isRequired,
            importGroupMembers: PropTypes.func.isRequired,
            importing: PropTypes.bool.isRequired,
            importResults: IPropTypes.list.isRequired,
            loading: PropTypes.bool.isRequired,
            notFound: PropTypes.number.isRequired,
            ok: PropTypes.number.isRequired,
            setupImportResultsState: PropTypes.func.isRequired,
            total: PropTypes.number.isRequired,
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
